import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { useTimeOfDay } from '../../hooks/useTimeOfDay';
import './Auth.css';

function PasswordResetRequest() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const timeOfDay = useTimeOfDay();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setError(null);

    try {
      await authAPI.requestPasswordReset(email);
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  const backgroundImage = timeOfDay === 'morning'
    ? 'url(/loginmorn.png)'
    : 'url(/loginday.jpg)';

  if (submitted) {
    return (
      <div className="auth-page" style={{ backgroundImage }}>
        <div className="auth-card">
          <div className="auth-header">
            <img src="/logo.png" alt="WFMZ" className="auth-logo" />
            <h1 className="auth-title">Check Your Email</h1>
            <p className="auth-subtitle">
              If an account exists for {email}, you will receive a password reset link.
            </p>
          </div>
          <div className="auth-footer">
            <Link to="/login">Back to Sign In</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page" style={{ backgroundImage }}>
      <div className="auth-card">
        <div className="auth-header">
          <img src="/logo.png" alt="WFMZ" className="auth-logo" />
          <h1 className="auth-title">Reset Password</h1>
          <p className="auth-subtitle">
            Enter your email address and we'll send you a link to reset your password.
          </p>
        </div>

        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              autoComplete="email"
              autoFocus
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg auth-submit"
            disabled={loading || !email}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-footer">
          <Link to="/login">Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
}

export default PasswordResetRequest;
